import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Router } from '@angular/router';

import { LoginService } from '../shared/services/login-service';
import { AuthService } from '../shared/auth/auth-service';
import { StorageService } from '../shared/auth/storage-service';
import { Login } from '../shared/model/login.model';

@Component({
  selector: 'app-emp-login',
  templateUrl: './emp-login.component.html',
  styleUrls: ['./emp-login.component.scss']
})
export class EmpLoginComponent implements OnInit {
  login: Login = new Login();
  show_button: Boolean = false;
  show_eye: Boolean = false;
 

  constructor(
    private toastr: ToastrService,
    private userLogInServices: LoginService,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/admin/dashboard')
    }
  }
  ngOnInit(): void {
   
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  loginUser() {
    this.userLogInServices.userLogin(this.login).subscribe((res: any) => {
      if (res && res.body && res.status == 200) {
        const token = res.body.response.token;
        this.authService.setToken(token);
        this.authService.setAuthTokenInCookie(token);
        this.storageService.saveUser(res.body.response)
        this.toastr.success(res.body.message)
        this.router.navigateByUrl('/admin/dashboard');
        const authToken = this.authService.getAuthTokenFromCookie();
      };
    }, (err: any) => {
      this.toastr.error(err.error.message)
    })
  }
  loginVendor() {
    this.router.navigateByUrl('/vendor-login')
  }
  GuestUser() {
    this.router.navigateByUrl('/guest-user')
  }
  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  requestResetPassword() { }
}
